import type { MumulLiveProfileStatus } from 'shared/src/api';

export type MumulLiveStatusDisplay = {
  ringColor: string;
  dotColor: string;
  text: string;
  textColor: string;
};

/**
 * 무물라이브 프로필 상태별 마켓홈 프로필 표시 정보.
 * DEFAULT 는 별도 표시가 없으므로 제외한다.
 */
const MUMUL_LIVE_STATUS_DISPLAY: Record<
  Exclude<MumulLiveProfileStatus, 'DEFAULT'>,
  MumulLiveStatusDisplay
> = {
  LIVE: {
    ringColor: '#EC0000',
    dotColor: '#EC0000',
    text: '무물라이브 진행중',
    textColor: '#EC0000',
  },
  HAS_UNREAD_STORY: {
    ringColor: '#006AFF',
    dotColor: '#006AFF',
    text: '새로운 스토리가 올라왔어요',
    textColor: '#1F1F1F',
  },
  ALL_READ_STORY: {
    ringColor: '#CCCCCC',
    dotColor: '#006AFF',
    text: '최근 스토리 보기',
    textColor: '#777777',
  },
};

/**
 * 상태값에 해당하는 표시 정보를 반환한다. DEFAULT 이거나 없으면 null.
 */
export const getMumulLiveStatusDisplay = (
  status: MumulLiveProfileStatus | null | undefined,
): MumulLiveStatusDisplay | null => {
  if (status == null || status === 'DEFAULT') {
    return null;
  }
  return MUMUL_LIVE_STATUS_DISPLAY[status];
};
